<template>
  <!-- NUMERIC field -->
  <div v-if="column.type === 'numeric'" style="" class="mt-1 text-center">
    <div style="display: inline-block; border-right: 2px solid lightgray;" class="px-3 text-center">
      <small>Minimum</small>
      <h5>{{column['min'] | formatMoney}}</h5>
    </div>
    <div style="display: inline-block; border-right: 2px solid lightgray;" class="px-3 text-center">
      <small>Maximum</small>
      <h5>{{column['max'] | formatMoney}}</h5>
    </div>
    <div style="display: inline-block; border-right: 2px solid lightgray;" class="px-3 text-center">
      <small>Average</small>
      <h5>{{column['mean'] | formatMoney}}</h5>
    </div>
    <div v-if="column.median" style="display: inline-block;" class="px-3 text-center">
      <small>Median</small>
      <h5>{{column['median'] | formatMoney}}</h5>
    </div>
    <br/>
    <hr />
    <div v-if="column.unique" style="display: inline-block; border-right: 2px solid lightgray;" class="px-3 text-center">
      <small>Unique</small>
      <h5>{{column['unique']}}</h5>
    </div>
    <div v-if="column.percent_unique" style="display: inline-block; border-right: 2px solid lightgray;" class="px-3 text-center">
      <small>Unique (%)</small>
      <h5>{{column['percent_unique'] * 100 | formatMoney}}</h5>
    </div>
    <div v-if="column.non_null_count" style="display: inline-block; border-right: 2px solid lightgray;" class="px-3 text-center">
      <small>Not Empty</small>
      <h5>{{column['non_null_count']}}</h5>
    </div>
    <div v-if="column.std" style="display: inline-block;" class="px-3 text-center">
      <small>Std Dev</small>
      <h5>{{column['std'] | formatMoney}}</h5>
    </div>
  </div>

  <!-- BOOLEAN field -->
  <div v-else-if="column.type === 'bool'" style="" class="mt-1 text-center">
    <div v-if="column.unique" style="display: inline-block; border-right: 2px solid lightgray;" class="px-3 text-center">
      <small>Unique</small>
      <h5>{{column['unique']}}</h5>
    </div>
    <div v-if="column.percent_unique" style="display: inline-block; border-right: 2px solid lightgray;" class="px-3 text-center">
      <small>Unique (%)</small>
      <h5>{{column['percent_unique'] * 100 | formatMoney}}</h5>
    </div>
    <div v-if="column.non_null_count" style="display: inline-block; border-right: 2px solid lightgray;" class="px-3 text-center">
      <small>Not Empty</small>
      <h5>{{column['non_null_count']}}</h5>
    </div>
  </div>

  <!-- DATETIME field -->
  <div v-else-if="column.type === 'datetime'" style="" class="mt-1 text-center">
    <div style="display: inline-block; border-right: 2px solid lightgray;" class="px-3 text-center">
      <small>Start Date</small>
      <h5>{{formatDate(column['min'])}}</h5>
    </div>
    <div style="display: inline-block;" class="px-3 text-center">
      <small>End Date</small>
      <h5>{{formatDate(column['max'])}}</h5>
    </div>
    <br/>
    <hr />
    <div v-if="column.unique" style="display: inline-block; border-right: 2px solid lightgray;" class="px-3 text-center">
      <small>Unique</small>
      <h5>{{column['unique']}}</h5>
    </div>
    <div v-if="column.percent_unique" style="display: inline-block; border-right: 2px solid lightgray;" class="px-3 text-center">
      <small>Unique (%)</small>
      <h5>{{column['percent_unique'] * 100 | formatMoney}}</h5>
    </div>
    <div v-if="column.non_null_count" style="display: inline-block; border-right: 2px solid lightgray;" class="px-3 text-center">
      <small>Not Empty</small>
      <h5>{{column['non_null_count']}}</h5>
    </div>
  </div>

  <!-- STRING field -->
  <div v-else style="" class="mt-1 text-center">
    <div v-if="column.unique" style="display: inline-block; border-right: 2px solid lightgray;" class="px-3 text-center">
      <small>Unique</small>
      <h5>{{column['unique']}}</h5>
    </div>
    <div v-if="column.percent_unique" style="display: inline-block; border-right: 2px solid lightgray;" class="px-3 text-center">
      <small>Unique (%)</small>
      <h5>{{column['percent_unique'] * 100 | formatMoney}}</h5>
    </div>
    <div v-if="column.non_null_count" style="display: inline-block; border-right: 2px solid lightgray;" class="px-3 text-center">
      <small>Not Empty</small>
      <h5>{{column['non_null_count']}}</h5>
    </div>
    <div v-if="column.max_len" style="display: inline-block; border-right: 2px solid lightgray;" class="px-3 text-center">
      <small>Max Length</small>
      <h5>{{column['max_len']}}</h5>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

const _type = obj => obj ? obj.type : null;
const dateFormat = 'Y-MM-DD hh:mm';

export default {
  name: 'MoreInfo',
  
  components: {},
  
  props: {
    column: Object
  },

  data() {
    return {};
  },

  methods: {
    formatDate(d) {
      return moment(d).format(dateFormat);
    },
  }
}
</script>

<style scoped>

</style>